import { GridItemBanner, GridItemMultiBanner } from './GridItemBanner';
import GridItemMenu, { ObjectFit } from './GridItemMenu';
import GridItemStill from './GridItemStill';

import GridItemHero from './GridItemHero';
import React from 'react';
import { mergeClassNames } from '../../../utils';
import styles from './index.module.scss';
import { useDebug } from '../../../context/Debug';

export default function Grid({ children, id = '', className = '', style = {} }) {
  let debug = useDebug();
  return (
    <ul id={id} className={mergeClassNames(styles.grid, debug ? styles.debug : null, className)} style={style}>
      {children}
    </ul>
  );
}

const GridSize = {
  default: 'Default',
  wide: 'Wide',
  tall: 'Tall',
  big: 'Big',
  autoLayout: 'AutoLayout',
};

export function GridItem({ children, className = '', to = undefined, gridSize = 'Default' }) {
  return (
    <li className={mergeClassNames(styles.gridItem, className, styles[gridSize])}>
      {to ? (
        <a href={to} target={to.startsWith('//') ? '_blank' : '_self'} rel="noreferrer">
          {children}
        </a>
      ) : (
        children
      )}
    </li>
  );
}

export { GridItemStill, GridItemMenu, GridItemBanner, GridItemHero, GridItemMultiBanner, ObjectFit, GridSize };
